import React from "react";

interface ToggleSwitchProps {
  name?: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  name,
  label,
  checked,
  onChange,
  disabled = false,
  className = "",
}) => {
  const handleToggle = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <div
      className={`flex items-center justify-start gap-x-2 ${className}`}
      style={{ marginRight: "7px" }}
    >
      {label ? <span className="min-w-[60px]">{label}</span> : null}

      <label
        className={`relative inline-block min-w-10 h-6 cursor-pointer ${
          disabled ? "opacity-50 cursor-not-allowed" : ""
        }`}
      >
        <input
          name={name}
          type="checkbox"
          className="sr-only peer"
          checked={checked}
          onChange={handleToggle}
          disabled={disabled}
        />
        <div className="absolute top-0 left-0 w-full h-full bg-gray-300 rounded-full bg-mobasher-gray shadow-inner transition-colors duration-300 ease-in-out peer-checked:bg-green-500 peer-checked:shadow-[inset_0_0_0_2px_#2D667F] peer-checked:bg-[#2D667F]"></div>
        <div className="absolute top-1 left-1 w-4 h-4 bg-white rounded-full shadow-md transition-transform duration-300 ease-in-out peer-checked:translate-x-4"></div>
      </label>
    </div>
  );
};

export default ToggleSwitch;
